export let capacitaciones: any[] = [
  {
    id: 1,
    nombre: 'Capacitaciones en Seguridad industrial',
    desc: 'Es un área multidisciplinaria que se encarga de minimizar los riesgos en la industria. Parte del supuesto de que toda actividad industrial tiene peligros inherentes que necesitan de una correcta gestión.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 2,
    nombre: 'Capacitaciones de Evacuacion',
    desc: 'Dar a conocer al personal una serie de instrucciones de carácter general que les permita responder de manera adecuada ante una eventualidad de una situación de emergencia, minimizando la probabilidad de lesiones del personal.',
    img: 'assets/img/app/appimg5.png'
  }
];



// WEBPACK FOOTER //
// G:/proyectos/website - IntergraMAI/webMai/src/assets/capacitaciones.data.ts